module.exports = __webpack_public_path__ + "static/media/hero-mobile.474c5a3c.jpg";